import { Navigate, Outlet } from "react-router-dom";

const useAuth = () => {
  const data = localStorage.getItem('loggedIn');
  const user = { loggedIn: data };
  return user && user.loggedIn;
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  return isAuth ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;